// -- IMPORTS

import { getLocalizedText, getLocalizedTextBySlug, getProcessedMultilineText } from 'senselogic-gist';
import { get } from 'svelte/store';
import { languageTagStore } from './store/languageTagStore';
import { derived, writable } from 'svelte/store'

// -- VARIABLES

export let hostUrl = getHostUrl();
export let websiteUrl = 'https://bamhub.com';

// -- FUNCTIONS

export async function fetchData(
    route,
    options = { method: 'GET' }
    )
{
    let url = hostUrl + route;

    try
    {
        let response = await fetch( url, options );

        if ( !response.ok )
        {
            throw new Error( 'Network response was not ok: ' + response.status );
        }

        return await response.json();
    }
    catch ( error )
    {
        console.error( 'There was a problem with your fetch operation:', error );

        throw error;
    }
}

// ~~

export function clickOutside(
    node
    )
{
    function handleClickEvent(
        event
        )
    {
        if ( node && !node.contains( event.target ) && !event.defaultPrevented )
        {
            node.dispatchEvent(
                new CustomEvent( 'clickOutside', node )
                );
        }
    }

    document.addEventListener( 'click', handleClickEvent, true );

    return (
        {
            destroy()
            {
                document.removeEventListener( 'click', handleClickEvent, true );
            }
        }
        );
}

// ~~

export function portal(
    node,
    targetId="portal-root"
    )
{
    let target = document.getElementById( targetId );

    if ( target )
    {
      target.appendChild(node);
    }

    return {
      destroy() {
        if ( target
             && node.parentNode === target )
        {
            target.removeChild( node );
        }
      }
    };
}

// ~~

export function getProcessedMultilineTranslatedText( text, variableMap = {} )
{
    if ( !text || ( typeof text !== 'string' && typeof text !== 'object' ) )
        return '';

    let processedText = getProcessedMultilineText(  
        getLocalizedText( text, variableMap, get( languageTagStore ) )
            .replaceAll('\\n', '\n')
            .replaceAll( '\"', '')
        );

    return processedText;
}


// ~~

export function getProcessedMultilineTranslatedTextBySlug( text, variableMap = {} )
{
    let processedText = getProcessedMultilineText( getLocalizedTextBySlug( text, variableMap, get( languageTagStore ) ).replace('\\n', '\n') );

    return processedText;
}

// ~~

export function isObjectEmpty(
    object
    )
{
    for ( var key in object )
    {
        if ( object.hasOwnProperty( key ) && object[ key ].trim() !== '' )
        {
            return false;
        }
    }

    return true;
}

// ~~

export function createUrlStore(
    ssrUrl
    )
{
    if ( typeof window === 'undefined' ) {
    let { subscribe } = writable( ssrUrl )
      return { subscribe }
    }

    let href = writable( window.location.href )

    let originalPushState = history.pushState
    let originalReplaceState = history.replaceState

    let updateHref = () => href.set( window.location.href )

    history.pushState =
        function () {
            originalPushState.apply( this, arguments )
            updateHref()
        }

    history.replaceState =
        function () {
            originalReplaceState.apply(this, arguments)
            updateHref()
        }

    window.addEventListener('popstate', updateHref)
    window.addEventListener('hashchange', updateHref)

    return {
        subscribe: derived(
                href,
                ( $href ) =>
                    new URL( $href ) )
                        .subscribe
    }
}

// ~~

export function createLoadObserver(
    handler
    )
{
    let waiting = 0

    function onload(
        element
        )
    {
        waiting++
        element.addEventListener(
            'load',
            () => {
                waiting--
                if ( waiting === 0 )
                {
                    handler()
                }
            }
        )
    }

    return onload
}

// ~~

function getHostUrl(
    subdomain = 'www'
    ) 
{
    const development = import.meta.env.MODE === 'development';

    if (development) {
        return 'http://localhost:8000';
    } else {
        return `https://${subdomain}.bamhub.com`;
    }
}
